import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="relative py-12 md:py-20 px-6 md:px-8 bg-cream overflow-hidden" data-id="element-242">
      {/* Dual ambient glows */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[350px] bg-sage/[0.04] rounded-full blur-[120px] pointer-events-none" data-id="element-243" />
      <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[250px] h-[200px] bg-terracotta/[0.03] rounded-full blur-[80px] pointer-events-none" data-id="element-244" />

      <motion.div initial={{
      opacity: 0,
      y: 24
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-80px'
    }} transition={{
      duration: 0.9,
      ease: [0.25, 0.1, 0.25, 1]
    }} className="max-w-2xl mx-auto relative z-10" data-id="element-245">
        {/* Ornamental top sparkle */}
        <div className="flex items-center justify-center gap-3 mb-6" data-id="element-246">
          <div className="h-px w-12 bg-gradient-to-r from-transparent to-sage/30" data-id="element-247" />
          <span className="text-sage/40 text-xs tracking-[0.3em]" data-id="element-248">✦ ✦ ✦</span>
          <div className="h-px w-12 bg-gradient-to-l from-transparent to-sage/30" data-id="element-249" />
        </div>

        <div className="relative rounded-2xl md:rounded-3xl border border-brown/[0.06] overflow-hidden" style={{
        background: 'linear-gradient(165deg, #FFFFFF 0%, #FAF7F2 60%, #F5F0E8 100%)',
        boxShadow: '0 1px 3px rgba(61,50,41,0.04), 0 8px 32px rgba(139,152,119,0.07), 0 24px 56px rgba(61,50,41,0.04)'
      }} data-id="element-250">
          {/* Top accent strip — sage to terracotta whisper */}
          <div className="h-[3px] w-full" style={{
          background: 'linear-gradient(90deg, transparent 5%, rgba(139,152,119,0.35) 35%, rgba(183,114,90,0.2) 65%, transparent 95%)'
        }} data-id="element-251" />

          {/* Warm radial glow from top */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-3/4 h-32 pointer-events-none" style={{
          background: 'radial-gradient(ellipse at top, rgba(139,152,119,0.07) 0%, transparent 70%)'
        }} data-id="element-252" />

          {/* Large decorative watermark */}
          <div className="absolute -right-4 -bottom-4 font-serif text-[140px] md:text-[180px] leading-none text-sage/[0.03] pointer-events-none select-none" aria-hidden="true" data-id="element-253">
            ✦
          </div>

          <div className="p-8 md:p-10 lg:p-14 flex flex-col items-center text-center relative" data-id="element-254">
            {/* Shield icon with layered glow */}
            <div className="relative mb-6" data-id="element-255">
              {/* Outer soft glow ring */}
              <div className="absolute inset-0 -m-3 rounded-full bg-sage/[0.06] blur-md pointer-events-none" data-id="element-256" />
              <div className="relative w-20 h-20 md:w-24 md:h-24 rounded-2xl flex items-center justify-center" style={{
              background: 'linear-gradient(145deg, rgba(139,152,119,0.1) 0%, rgba(139,152,119,0.04) 100%)',
              boxShadow: 'inset 0 1px 6px rgba(139,152,119,0.12), 0 4px 20px rgba(139,152,119,0.1)'
            }} data-id="element-257">
                <ShieldCheck className="w-10 h-10 md:w-12 md:h-12 text-sage-dark/60" strokeWidth={1.4} data-id="element-258" />
              </div>
              {/* Decorative dots */}
              <div className="absolute -bottom-1 -right-1 w-2.5 h-2.5 rounded-full bg-sage/25" data-id="element-259" />
              <div className="absolute -top-1 -left-1 w-2 h-2 rounded-full bg-terracotta/15" data-id="element-260" />
            </div>

            {/* Label */}
            <p className="text-[10px] uppercase tracking-[0.3em] text-sage-dark/50 font-bold mb-3" data-id="element-261">
              14-Day Gentle Guarantee
            </p>

            {/* Heading */}
            <h2 className="font-serif text-2xl md:text-3xl lg:text-[2rem] text-brown mb-2 leading-snug" data-id="element-262">
              Try It Completely Risk-Free
            </h2>

            {/* Decorative thin divider */}
            <div className="w-16 h-px bg-gradient-to-r from-transparent via-brown/15 to-transparent my-4" data-id="element-263" />

            {/* Body */}
            <p className="text-brown-light/75 text-base md:text-lg leading-relaxed max-w-lg mb-5" data-id="element-264">
              If you don't gain meaningful personal windows — your
              30&nbsp;minutes of protected time — within 14&nbsp;days, request a
              full refund.
            </p>

            {/* Closing serif line with decorative quotes */}
            <div className="relative inline-block" data-id="element-265">
              <span className="absolute -left-5 -top-2 font-serif text-2xl text-sage/20 select-none pointer-events-none" aria-hidden="true" data-id="element-266">
                "
              </span>
              <p className="font-serif text-base md:text-lg italic text-brown/45 leading-relaxed" data-id="element-267">
                No questions asked. No stress. No shame.
              </p>
              <span className="absolute -right-4 -bottom-2 font-serif text-2xl text-sage/20 select-none pointer-events-none" aria-hidden="true" data-id="element-268">
                "
              </span>
            </div>
          </div>
        </div>

        {/* Bottom ornamental line */}
        <div className="flex items-center justify-center mt-6" data-id="element-269">
          <div className="h-px w-20 bg-gradient-to-r from-transparent via-brown/10 to-transparent" data-id="element-270" />
        </div>
      </motion.div>
    </section>;
}